import { forwardRef } from 'react';

const ServiceCard = forwardRef(({ icon, title }, ref) => (
  <article
    ref={ref}
    className="servicios__service servicios__service--home"
  >
    <div className="servicios__icon-wrapper">
      <img
        src={icon}
        alt=""
        aria-hidden="true"
        className="servicios__icon"
        loading="lazy"
        decoding="async"
      />
    </div>
    <h3 className="servicios__service-title">{title}</h3>
  </article>
));

ServiceCard.displayName = 'ServiceCard';

export default ServiceCard;
